import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import * as actions from 'store/modules/content';
import { withRouter } from 'react-router';
import { reloadIframe } from 'helpers/reloadIframe';
import { getUrl } from 'helpers/getUrl';

import AccountForm from './AccountForm';
import AlertMessage from 'components/AlertMessage';
import classnames from 'classnames';
import getEnv from 'helpers/getEnv';

import videoSvg from 'images/video-solid.svg';

const DELAY = 4000;

class MainInfo extends Component {
  state = {
    isImageLoading: false,
    showAlertSuccess: false,
    showAlertError: false,
    alertErrorText: '',
  };

  spinnerStart = () => {
    this.setState({ isImageLoading: true });
  };

  spinnerStop = () => {
    this.setState({
      isImageLoading: false,
    });
  };

  handleUpdateAccount = async (
    params,
    setSubmitting,
    setErrors,
    toggleSpinner,
  ) => {
    let shouldReload = false;
    const { updateAccountAction, account, match } = this.props;
    const data = {
      account: {
        domain: params.domain,
        short_code: params.shortCode,
        title: params.title,
        show_general_info: params.show_general_info,
        subtitle: params.subtitle,
        image: params.image,
      },
    };
    if (
      account.domain !== params.domain ||
      account.title !== params.title ||
      account.subtitle !== params.subtitle
    ) {
      shouldReload = true;
    }
    // if (params.image) {
    //   data.image = params.image;
    // }
    const id = match.params.id;
    const response = await updateAccountAction(
      id,
      data,
      setSubmitting,
      setErrors,
      toggleSpinner,
    );
    if (response.code === 200 && typeof response !== 'object') {
      this.setState({
        showAlertSuccess: true,
      });
      setTimeout(
        () =>
          this.setState({
            showAlertSuccess: false,
          }),
        DELAY,
      );
      if (shouldReload) {
        const url = getUrl(
          getEnv('REACT_APP_BACKEND_URL'),
          account.short_code,
          {
            preview: true,
          },
        );
        reloadIframe(url);
      }
    }
    if (params.image && response.error) {
      this.setState({
        showAlertError: true,
        alertErrorText: response.textError.image[0]
          ? response.textError.image[0]
          : 'Your image was not uploaded',
      });
      setTimeout(() => this.setState({ showAlertError: false }), DELAY);
    }
    this.spinnerStop();
  };

  render() {
    const { account } = this.props;
    const {
      short_code,
      title,
      subtitle,
      domain,
      total_clicks,
      total_views,
    } = this.props.account;
    const { user } = this.props;
    const {
      isImageLoading,
      showAlertSuccess,
      showAlertError,
      alertErrorText,
    } = this.state;
    return (
      <Fragment>
        {showAlertSuccess && <AlertMessage text="Your image uploaded" />}
        {showAlertError && (
          <AlertMessage
            classAlert={classnames({ error: true })}
            text={alertErrorText}
          />
        )}
        <h3 className="h3-title">General information</h3>
        <div className="separator-line" />
        <AccountForm
          account={account}
          domain={domain}
          shortCode={short_code}
          title={title}
          subtitle={subtitle}
          handleSubmit={this.handleUpdateAccount}
          total_clicks={total_clicks}
          total_views={total_views}
          user={user}
          spinner={isImageLoading}
          spinnerStart={this.spinnerStart}
        />
      </Fragment>
    );
  }
}

function mapStateProps(state) {
  return {
    account: state.content.account,
    user: state.details.user,
  };
}
export default connect(
  mapStateProps,
  actions,
)(withRouter(MainInfo));



// WEBPACK FOOTER //
// ./src/components/MainInfo/MainInfo.js